// ------ Validation Schema ------
import * as Yup from "yup";
import { FormField } from "../../interfaces/User.interface";

export const validationMap: Record<string, Yup.Schema<any>> = {
    text: Yup.string(),
    //增加course类型
    course: Yup.object(),
    email: Yup.string()
        .matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            "Invalid email format"
        )
        .required("Email is required"),
    // phone validator updated to only accept xxx-xxx-xxxx format
    phone: Yup.string()
        .matches(
            /^\d{3}-\d{3}-\d{4}$/,
            {
                message: "Phone must be in the format xxx-xxx-xxxx",
                excludeEmptyString: true
            }
        ),

    number: Yup.number().min(0).typeError('This field must be a number'),
    object: Yup.object(),
    objectArray: Yup.array().of(Yup.object()).min(1, "This field is required"),
    postal: Yup.string()
    .matches(
      /^(?:[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d|\d{5}(?:-\d{4})?)$/,
            {
                message: "Postal Code must be in the format A1A 1A1, 12345, or 12345-6789",
                excludeEmptyString: true
            }
    ),
  

    password: Yup.string()
        .min(8, "Password must be at least 8 characters long")
        .matches(/[a-z]/, "Password must contain at least one lowercase letter")
        .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
        .matches(/[0-9]/, "Password must contain at least one number")
        .required("Password is required"),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref('password')], 'Passwords must match')
        .required('Confirm Password is required'),
    boolean: Yup.boolean(),

    expiryDate: Yup.string()
        .matches(/^(0[1-9]|1[0-2])\/\d{2}$/, "Invalid expiry date format")
        .required("Expiry date is required"),
    cvv: Yup.string()
        .matches(/^\d{3}$/, "Invalid CVV format")
        .required("CVV is required"),
    name: Yup.string()
        .matches(/^[a-zA-Z ]+$/, "Invalid name format")
        .required("Name is required"),
    cardNumber: Yup.string()
        .matches(/^\d{16}$/, "Invalid card number format")
        .required("Card number is required"),
};

const _generateValidationSchema = <T extends {}>(fields: FormField[]): Record<keyof T, Yup.Schema<any>> => {
    return fields
        .filter((field) => field.validation)
        .reduce((schema, field) => {
            if (field.required === true) {
                const validation = validationMap[field.validation!]
                    .required("This field is required");
                schema[field.name as keyof T] = validation;
            } else {
                const validation = validationMap[field.validation!]
                    .nullable();
                schema[field.name as keyof T] = validation;
            }
            // const validation = validationMap[field.validation!]
            //         .nullable();
            //     schema[field.name as keyof T] = validation;
            return schema;
        }, {} as Record<keyof T, Yup.Schema<any>>);
};

export const generateValidationSchema = <T extends {}>(formFields: FormField[]): Yup.ObjectSchema<T> => {
    const schemaFields = _generateValidationSchema<T>(formFields);
    return Yup.object(schemaFields) as unknown as Yup.ObjectSchema<T>;
};

// Adaptation to work with useFieldArray
export const generateValidationSchemaArray = <T extends {}>(formFields: FormField[], fieldName: string): Yup.ObjectSchema<T> => {
    const schemaFields = _generateValidationSchema<T>(formFields);

    // Wrap the schemaFields in Yup.array if you want to validate an array of fields
    return Yup.object({
        [fieldName]: Yup.array().of(
            Yup.object(schemaFields)
        )
    }) as unknown as Yup.ObjectSchema<T>;
};


